import { render, staticRenderFns } from "./SmartMatchSettings.vue?vue&type=template&id=9c5f5ca8&"
import script from "./SmartMatchSettings.vue?vue&type=script&lang=js&"
export * from "./SmartMatchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports